import { Component, Vue } from 'vue-property-decorator'
import JISTRDRCTService from './JISTRDRCTService'
import Cookies from 'js-cookie'
@Component({
  name: 'JISTRDRCT'
  })
export default class JISTRDRCTController extends Vue {
  private jistrdrctService: JISTRDRCTService = new JISTRDRCTService()

  /**
   * 画面要素描画後処理
   */
  created() {
    this.init()
  }

  /**
   * 初期処理
   */
  private async init() {
    const jistDirectUrl =
      process.env.VUE_APP_BASE_URL_DLS + this.$route.fullPath
    const xsrfToken = Cookies.get('XSRF-TOKEN')
    this.jistrdrctService.callAPICAAA1015(jistDirectUrl, xsrfToken)
  }
}
